import { render, staticRenderFns } from "./DailyChatVersionRetoucherRatings.vue?vue&type=template&id=b5cdee42&"
import script from "./DailyChatVersionRetoucherRatings.vue?vue&type=script&lang=js&"
export * from "./DailyChatVersionRetoucherRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports